import React, { useState } from 'react'
import PropTypes from 'prop-types'


import { changeFormObject } from 'src/redux/products/productsSlice';
import { getAllSegmentList, getSegmentCodeDetails } from 'src/redux/products/productThunk';
import { Tab } from 'semantic-ui-react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
// import { findVal } from '../../../../helper/CustomHook';
import { Dropdown, Popup } from 'semantic-ui-react';
// import MultiLangTabWrapper from '../../components/MultiLangTabWrapper';
import { useTranslation } from 'react-i18next';
import { IoIosHelpCircleOutline } from 'react-icons/io'
import { restrictionsData } from 'src/helper/MetadataCollection';
import { InputTextWithLabel } from 'src/components/inputComponents/InputTextWithLabel';
import { InputSelectDropdown } from 'src/components/inputComponents/InputSelectDropdown';
import { MdClose, MdSend } from 'react-icons/md';
import { IconButton } from 'src/components/IconButton';


export const Restrictions = props => {
  const {
    /** name, value, label, readOnly, onChange */
} = props



const { t } = useTranslation('common');

const dispatch = useDispatch();

const productState = useSelector((state) => (state.products));
const productData = productState.formObject // productData === formObject


  const resetRestrictionsHandle = () => {
    let restrictedData = { ...productData.restricted }
    restrictedData.type = "";
    restrictedData.value = "";
    dispatch(changeFormObject({ ...productData, restricted: restrictedData, isChange: 1 }))
  }


  const handleFormChange = (e, data) => {
    let restrictedData = productData.restricted
    if (!!data) {
      restrictedData = { ...restrictedData, [data.name]: data.value }
    } else {
      restrictedData = { ...restrictedData, [e.target.name]: e.target.value }
    }
    dispatch(changeFormObject({ ...productData, restricted: restrictedData, isChange: 1 }))
  };

  return (
    <div style={{ marginBottom: 16 }} className="row col-lg-12">
      <div className='d-flex' style={{ marginLeft: -15 }}>
        <span className='col-lg-9 col-md-9 col-sm-9 col-9 mb-3' style={{ color: '#253C4B', fontSize: 14, fontWeight: 'bold' }}>{t("_Restrictions")}
          <Popup
            pinned wide='very' position='top center'
            //  flowing
            on={'click'}
            trigger={<IoIosHelpCircleOutline style={{ marginBottom: 2, color: '#6c757d', cursor: 'pointer', marginLeft: 5 }} fontWeight={'bold'} />} >
            <p>{t('Restrictions')}</p>
          </Popup>
        </span>
        {productState.isProdEditMode &&
          <div className='col-lg-3 col-md-3 col-sm-3 col-3' style={{ cursor: 'pointer' }}>
            <IconButton text={t("Reset")} icon={MdClose} onClick={() => resetRestrictionsHandle()} />
          </div>}
      </div>

      <InputSelectDropdown
        label={t("Type")}
        tooltipText={t('Restriction Type')}
        showTooltip={true}
        placeholder={t('Restriction Type')}
        name="type"
        search={true}
        value={!!productData.restricted ? productData.restricted.type : ''}
        options={restrictionsData}
        onChange={handleFormChange}
        readOnly={productState.isProdEditMode ? false : true}
      />

      <InputTextWithLabel
        label={t('Value')}
        tooltipText={t('Restriction Value')}
        showTooltip={true}
        onChange={handleFormChange}
        name={"value"}
        value={!!productData.restricted ? productData.restricted.value : ''}
        type="text"
        placeholder={t('Restriction Value')}
        readOnly={productState.isProdEditMode ? false : true}
      ></InputTextWithLabel>

    </div>
  )
}

Restrictions.propTypes = {}
